export const ANALYTICS_STATUSES = {
  enabled: "ENABLED",
  disabled: "DISABLED",
  processing: "PROCESSING",
  not_supported: "NOT_SUPPORTED",
  no_permission: "NO_PERMISSION",
};
